import React from 'react'
import { useLocation } from 'react-router-dom'
import { isKnownRoute } from '../utils/routeAccess'
import PageNotFound from './pageNotFound'

const UnknownRouteFallback = () => {
    const location = useLocation()

    if (isKnownRoute(location.pathname)) return null

    return <PageNotFound />
}

export default UnknownRouteFallback